import {useState} from "react";
import {cloneDeep, isEmpty} from "lodash";
import {useDispatch} from "react-redux";
import {toast} from "react-toastify";
import {createUpdateCustomFieldChoices} from "../../../redux/Actions/customFields.actions";
import {DEFAULT_FORM_DATA} from "./constants";

export const useFormData = (data = cloneDeep(DEFAULT_FORM_DATA), onCancel) => {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    ...data,
  });
  const {name} = formData;

  const handleChange = (e) => {
    setFormData((prevData) => ({...prevData, [e.target.name]: e.target.value}));
  };

  const handleChoiceChange = (index, field, value) => {
    setFormData((prevData) => {
      const updatedChoices = [...prevData.extra_choices];
      updatedChoices[index][field] = value;
      return {...prevData, extra_choices: updatedChoices};
    });
  };

  const addChoice = () => {
    setFormData((prevData) => ({
      ...prevData,
      extra_choices: [...prevData.extra_choices, {label: "", value: ""}],
    }));
  };

  const removeChoice = (index) => {
    setFormData((prevData) => ({
      ...prevData,
      extra_choices: prevData.extra_choices.filter((_, i) => i !== index),
    }));
  };

  const handleSubmit = () => {
    if (isEmpty(name) || isEmpty(formData.extra_choices)) {
      toast.error("Please check required fields");
      return;
    }

    if (
      formData.extra_choices.some(
        (choice) => isEmpty(choice.label) || isEmpty(choice.value)
      )
    ) {
      toast.error("All choices must have a label and value");
      return;
    }

    dispatch(createUpdateCustomFieldChoices(formData, onCancel));
  };

  return {
    addChoice,
    formData,
    handleChange,
    handleChoiceChange,
    handleSubmit,
    removeChoice,
  };
};
